import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Certificate } from "types/certificate";

interface CertificateState {
  isLoading: boolean;
  data: Certificate;
}

const initialState: CertificateState = {
  isLoading: false,
  data: {},
};

const certificateSlice = createSlice({
  name: "certificate",
  initialState: initialState,
  reducers: {
    getCertificate: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    saveCertificate: (state, action: PayloadAction<Certificate>) => {
      return {
        ...state,
        isLoading: false,
        data: {
          ...action.payload,
        },
      };
    },
    clearCertificate: (state) => {
      state = initialState;
      return state;
    },
  },
});

export const { saveCertificate, getCertificate, clearCertificate } = certificateSlice.actions;

export default certificateSlice.reducer;
